import {NavigateFunction, NavigationType} from "react-router-dom";

export const navigateTo = (path: string, navigate: NavigateFunction): void => {
    navigate(path);
};

export const notPopNavigation = (navigationType: NavigationType): boolean => {
    return navigationType !== NavigationType.Pop;
};
